import { render, staticRenderFns } from "./ProgressStar.vue?vue&type=template&id=0bdbfc26&scoped=true"
import script from "./ProgressStar.vue?vue&type=script&lang=ts"
export * from "./ProgressStar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressStar.vue?vue&type=style&index=0&id=0bdbfc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbfc26",
  null
  
)

export default component.exports